"use client"

import { Image } from "@/elements"
import { Video } from "@/components"
import React, { FC, useRef } from "react"
import { FragmentType, graphql, useFragment } from "@/gql"
import clsx from "clsx"

const ProjectMediaFragment = graphql(`
  fragment ProjectMedia on CreativeWorkPortfolioProjectFile {
    __typename
    id
    thumbnailUrl645w: thumbnailUrl(width: 645)
    thumbnailUrl1290w: thumbnailUrl(width: 1290)
    thumbnailUrl2000w: thumbnailUrl(width: 2000)

    metadata {
      video
    }
    ...Video
  }
`)

interface Props {
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  file: FragmentType<typeof ProjectMediaFragment> | undefined | null
  index: number
}

export const ProjectMedia: FC<Props> = ({ onClick, index, ...props }) => {
  const file = useFragment(ProjectMediaFragment, props.file)
  const imageRef = useRef<HTMLImageElement>(null)

  return (
    <div className={clsx("relative flex w-full")}>
      <div className="h-auto w-full">
        {file?.metadata?.video && file ? (
          <Video video={file} controls videoClassName="w-full h-auto" poster={file?.thumbnailUrl1290w ?? ""} />
        ) : (
          <Image
            onClick={onClick}
            ref={imageRef}
            fetchPriority={index < 5 ? "high" : "low"}
            srcSetUrls={{
              sm: file?.thumbnailUrl645w ?? "",
              md: file?.thumbnailUrl1290w ?? "",
              lg: file?.thumbnailUrl2000w ?? "",
              xl: file?.thumbnailUrl2000w ?? "",
            }}
            alt="Project image"
            className={clsx("h-auto w-full bg-bg-2", Boolean(onClick) ? "cursor-pointer" : "cursor-default")}
            onContextMenu={e => e.preventDefault()}
          />
        )}
      </div>
    </div>
  )
}
